module.exports = __webpack_public_path__ + "static/media/perfil.8439477c.svg";